import React from 'react';

const shimmerStyle = `
  @keyframes shimmer {
    0%   { background-position: -400px 0; }
    100% { background-position:  400px 0; }
  }
  .table-skeleton-cell {
    height: 16px;
    border-radius: 4px;
    background: linear-gradient(
      90deg,
      #2a2a2a 25%,
      #3a3a3a 50%,
      #2a2a2a 75%
    );
    background-size: 800px 100%;
    animation: shimmer 1.4s infinite linear;
  }
`;

const TableSkeleton = ({ rows = 5, columns = 5 }) => (
  <>
    <style>{shimmerStyle}</style>
    <tbody>
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <tr key={rowIdx}>
          {Array.from({ length: columns }).map((_, colIdx) => (
            <td key={colIdx} style={{ padding: '12px 16px' }}>
              <div
                className="table-skeleton-cell"
                style={{ width: colIdx === 0 ? '70%' : colIdx === columns - 1 ? '40%' : '85%' }}
              />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </>
);

export default TableSkeleton;
